import Wrapper from '../../assets/wrappers/Intro';
import Hello from '../../components/Hello';
import Picture from '../../components/Picture';
import { contentStyle } from '../../fuctions';


const GroupClassIntro = () => {
  return (
    <Wrapper>
      <div className="max-w-7xl px-4 mx-auto sm:px-6    ">
        <div className="relative pt-32 pb-10 md:pt-40 md:pb-16">
          <div style={contentStyle`
font-family: 'Inter';
font-style: normal;
font-weight: 600;
font-size: 35px;
line-height: 42px;

color: #000000;
`}>Find the best group classes for you to join in different aspects</div>
          <div style={contentStyle`
font-family: 'Inter';
font-style: normal;
font-weight: 400;
font-size: 20px;
line-height: 24px;

color: #5C5C5C;
`}>Engage in group classes with 2-6 trainees all over the world designed by expert coaches. </div>
        </div>
      </div>

    </Wrapper>
  );
};

export default GroupClassIntro;
